module.exports = __webpack_public_path__ + "img/cliente-1.aa385e8a.jpg";